import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'DetailsComponent',
  props: {
    textColor: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "gap-y-4 flex flex-wrap items-center justify-center",
    style: _normalizeStyle({ color: _ctx.textColor })
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 4))
}
}

})